<template>
  <p class="ba-flex ba-items-center ba-py-2 ba-select-none input-wrap input-wrap--checkbox">
    <input
      type="checkbox"
      :id="name"
      :checked="isChecked"
      @change="change"
      :value="name"
      :disabled="locked"
    />
    <label
      :for="name"
      class="ba-flex ba-justify-start ba-items-center ba-mb-0 ba-cursor-pointer"
    >{{ localizedName }}</label>
    <span
      v-if="required"
      class="ba-flex-shrink-0 ba-flex ba-justify-center ba-items-center ba-w-5 ba-h-5 ba-ml-2 ba-bg-white ba-text-black ba-font-bold ba-rounded-full"
    >!</span>
  </p>
</template>

<script>
import remove from "lodash/remove";

const scopeNames = {
  scope_user: "Пользователь",
  scope_filestorage: "Файловое хранилище",
  scope_filestorage_readonly: "Файловое хранилище (только чтение)",
  scope_account_manage: "Управление аккаунтом",
  scope_openid: "Ваш идентификатор пользователя",
  scope_phone: "Телефон",
  scope_chat: "Чат",
  scope_userprofile: "Профиль пользователя"
};

export default {
  name: "vis-concent-scope",
  props: {
    value: {
      type: Array,
      default: () => []
    },
    name: {
      type: String,
      required: true
    },
    locked: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    emphasize: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    localizedName() {
      const key = `scope_${this.name}`;
      return scopeNames[key] ?? this.name;
    },
    isChecked() {
      return this.value.indexOf(this.name) >= 0;
    }
  },
  methods: {
    change(event) {
      const values = this.value.slice();
      const { checked, value } = event.target;

      if (checked) {
        if (values.indexOf(event.target.value) === -1) {
          values.push(value);
        }
      } else {
        remove(values, (v) => v === value);
      }

      this.$emit("input", values);
    }
  }
};
</script>
